export default "__VITE_ASSET__5cf3670e__"